import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { INQUIRY_DETAIL_URL, INQUIRY_DELETE_URL, MAKING_SUPPORT_APPLY_DETAIL_URL, MAKING_SUPPORT_DELETE_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import PopupLoginError from "../../../components/Popup/LoginError";
import { useLanguage } from "../../../hooks/useLanguage";

function InquiryDetail({inquiryType}){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { b_seq } = useParams();
  const [inquiryDetail, setInquiryDetail] = useState(null);
  const [inquiryFiles, setInquiryFiles] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // 팝업
  // 목록 버튼 클릭 핸들러
  const handleBackToList = () => {
    navigate(`/myPage/${inquiryType}`);
  };

  // 수정 버튼 클릭 핸들러
  const handleEdit = () => {
    navigate('/community/inquiry/write', { 
      state: { 
        inquiryType: 'mypage',
        isEdit: true,
        editData: inquiryDetail,
        editFiles: inquiryFiles 
      } 
    });
  };

  const handleCustomizingEdit = () => {
    navigate(`/community/customizing/write?b_seq=${b_seq}`, { 
      state: { 
        from: 'mypage',
        isEdit: true,
        editData: inquiryDetail,
        editFiles: inquiryFiles 
      } 
    });
  };

  const handlePriceGuaranteeEdit = () => {
    navigate(`/community/priceGuarantee/write?b_seq=${b_seq}`, { 
      state: { 
        from: 'mypage',
        isEdit: true,
        editData: inquiryDetail,
        editFiles: inquiryFiles 
      } 
    });
  };

  // 제작지원 수정 버튼 클릭 핸들러 추가
  const handleSupportEdit = () => {
    navigate(`/community/support/write?apply_seq=${inquiryDetail?.apply_seq}`, { 
      state: { 
        from: 'mypage',
        isEdit: true,
        editData: inquiryDetail,
      } 
    });
  };

  // 1:1 문의 상세
  useEffect(()=> {
    if (inquiryType !== 'inquiry' && inquiryType !== 'customizing' && inquiryType !== 'priceGuarantee') return;
    const fetchInquiryDetail = async () => {
      try {
        const response = await instance.post(INQUIRY_DETAIL_URL, {
          b_seq: b_seq
        })
        setInquiryDetail(response.data.data.data);
        setInquiryFiles(response.data.data.files);
      } catch (error) {
        console.error('1:1 문의 상세 조회 오류:', error);
      }
    };
    fetchInquiryDetail();
  }, [b_seq, inquiryType]);

    // 제작지원 상세
    useEffect(()=> {
      if (inquiryType !== 'support') return;
      const fetchInquiryDetail = async () => {
        try {
          const response = await instance.post(MAKING_SUPPORT_APPLY_DETAIL_URL, {
            apply_seq: b_seq
          })
          setInquiryDetail(response.data.data);

        } catch (error) {
          console.error('1:1 문의 상세 조회 오류:', error);
        }
      };
      fetchInquiryDetail();
    }, [b_seq, inquiryType]);

    // 문의 삭제 핸들러 - 제작지원과 일반 문의 구분
    const handleDelete = async () => {
      try {
        let response;
        
        if (inquiryType === 'support') {
          // 제작지원 삭제
          response = await instance.post(MAKING_SUPPORT_DELETE_URL, {
            apply_seq: inquiryDetail?.apply_seq || b_seq
          });
        } else {
          // 일반 문의 삭제 (1:1문의, 커스터마이징, 최저가 보장)
          response = await instance.post(INQUIRY_DELETE_URL, {
            b_seq: b_seq
          });
        }
        
        if (response.data.success) {
          setIsPopupOpen({
            message: '문의가 삭제되었습니다.',
            action: 'navigate_list'
          });
        } else {
          setIsPopupOpen('문의 삭제에 실패했습니다.');
        }
      } catch (error) {
        console.error('문의 삭제 오류:', error);
        setIsPopupOpen('문의 삭제 중 오류가 발생했습니다.');
      }
    };

    // 팝업 확인 버튼 클릭 핸들러 수정
    const handleConfirm = () => {
      if (isPopupOpen.action === 'navigate_login') {
        navigate('/login');
      } else if (isPopupOpen.action === 'navigate_list') {
        navigate(`/myPage/${inquiryType}`); // 현재 inquiryType에 따라 동적으로 경로 설정
      }
      setIsPopupOpen(false);
    };

  return(
    <div className="inquiry_container">

      {inquiryType === 'support' ? (
        // 제작지원
        <div className="my_container point_container mt_48">
          <div className="order_title">
            <h3>{t('production_support')}</h3>
          </div>

          <div className="board_container form_board board_detail">
            <ul>
              <li 
                className="board_item"
              >
                <div className="board_box flex-4 column">
                  <h6 className="title flex-center-4 b1-2">
                    <span>{inquiryDetail?.work_title}</span>
                  </h6>
                  <div className="board_info board_line">
                    <span className="text_small g-70">{inquiryDetail?.regist_date}</span>
                  </div>
                </div>
                <div className="board_status">
                    {inquiryDetail?.status === '답변대기' ? (
                      <span className="badge yellow">{t('answer_pending')}</span>
                    ) : (
                      <span className="badge g-100">{t('answer_completed')}</span>
                    )}
                </div>
              </li>
            </ul>

            {/* 문의글 */}
            <div className="board_contents">
              <div dangerouslySetInnerHTML={{ __html: inquiryDetail?.apply_content }}></div>

              {/* 이미지 및 파일 표출 - main_image와 sub_images만 표시 */}
              {((inquiryDetail?.main_image && inquiryDetail.main_image.length > 0) ||
                (inquiryDetail?.sub_images && inquiryDetail.sub_images.length > 0)) && (
                <div className="board_bottom attach_file">
                  <div className="img_attach_box">
                    <ul className="preview_list">
                      {/* 대표 이미지 표시 */}
                      {inquiryDetail?.main_image && inquiryDetail.main_image.map((image, index) => (
                        <li className="default_btn ic_lg" key={`main-${index}`}>
                          <img
                            className="object-cover"
                            src={image.file_url}
                            alt={`대표 이미지 ${index + 1}`}
                            loading="lazy"
                          />
                        </li>
                      ))}
                      
                      {/* 서브 이미지 표시 */}
                      {inquiryDetail?.sub_images && inquiryDetail.sub_images.map((image, index) => (
                        <li className="default_btn ic_lg" key={`sub-${index}`}>
                          <img
                            className="object-cover"
                            src={image.file_url}
                            alt={`서브 이미지 ${index + 1}`}
                            loading="lazy"
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div> 
            
            {/* 답변 대기중 > 수정 가능 상태 */}
            {inquiryDetail?.status === '답변대기' && (
              <div className="btn_group edit_box">
                <button 
                  type="button" 
                  className="default_btn xs white" 
                  onClick={handleSupportEdit}
                >
                  {t('modify')}
                </button>
                <button
                  type="button"
                  className="default_btn xs white"
                  onClick={handleDelete}
                >
                  {t('delete')}
                </button>
              </div>
            )}
            

            {/* 답변 완료 > 수정 불가능 */}
            {inquiryDetail?.status === '답변완료' && inquiryDetail?.answer_content && (
              <div className="board_answer unset_box">
                <div dangerouslySetInnerHTML={{ __html: inquiryDetail?.answer_content }}></div>
              </div>
            )}
          </div>
        </div>

      ) : inquiryType === 'inquiry' ? (
        // 1:1문의
        <div className="my_container point_container mt_48">
          <div className="order_title">
            <h3>{t('inquiry')}</h3>
          </div>

          <div className="board_container form_board board_detail">
            <ul>
              <li 
                className="board_item"
              >
                <div className="board_box flex-4 column">
                  <h6 className="title flex-center-4 b1-2">
                    <span>{inquiryDetail?.subject}</span>
                  </h6>
                  <div className="board_info board_line">
                    <span className="text_small g-70">{inquiryDetail?.regist_date.split(' ')[0]}</span>
                      <span className="text_small g-70">{inquiryDetail?.board_type}</span>
                  </div>
                </div>

                <div className="board_status">
                  {inquiryDetail?.re_contents ? (
                    <span className="badge g-100">{t('answer_completed')}</span>
                  ) : (
                    <span className="badge yellow">{t('answer_pending')}</span>
                  )}
                </div>
              </li>
            </ul>

            {/* 문의글 */}
            <div className="board_contents">
              <div
                  dangerouslySetInnerHTML={{
                    __html: inquiryDetail?.contents ?? "",
                  }}
              />

              {/* 커뮤니티에서 첨부된 파일 표출 */}
              <div className="board_bottom attach_file">
                <div className="img_attach_box">
                  <ul className="preview_list">
                    {inquiryFiles.map((file, index) => (
                      <li className="default_btn ic_lg" key={index}>
                        <img
                          className="object-cover"
                        src={file.new_filepath}
                        alt="이미지 첨부"
                        loading="lazy"
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div> 
            
            {/* 답변 대기중 > 수정 가능 상태 */}
            {inquiryDetail?.re_contents === null && (
              <div className="btn_group edit_box">
                <button 
                  type="button" 
                className="default_btn xs white" 
                onClick={handleEdit}
                >
                  {t('modify')}
                </button>
                <button
                  type="button"
                  className="default_btn xs white"
                  onClick={handleDelete}
                >
                  {t('delete')}
                </button>
              </div>
            )}
            
            {/* 답변 완료 > 수정 불가능 */}
            {inquiryDetail?.re_contents && (
              <div className="board_answer unset_box">
                <div dangerouslySetInnerHTML={{ __html: inquiryDetail?.re_contents }}></div>
              </div>
            )}
          </div>
        </div> 

      ) : inquiryType === 'customizing' ? (
        // 커스터마이징
        <div className="my_container point_container mt_48">
          <div className="order_title">
            <h3>{t('customization')}</h3>
          </div>

          <div className="board_container form_board board_detail">
            <ul>
              <li 
                className="board_item"
              >
                <div className="board_box flex-4 column">
                  <h6 className="title flex-center-4 b1-2">
                    <span>{inquiryDetail?.subject}</span>
                  </h6>
                  <div className="board_info board_line">
                    <span className="text_small g-70">{inquiryDetail?.regist_date.split(' ')[0]}</span>
                      <span className="text_small g-70">{inquiryDetail?.board_type}</span>
                  </div>
                </div>

                <div className="board_status">
                  {inquiryDetail?.re_contents ? (
                    <span className="badge g-100">{t('answer_completed')}</span>
                  ) : (
                    <span className="badge yellow">{t('answer_pending')}</span>
                  )}
                </div>
              </li>
            </ul>

            {/* 문의글 */}
            <div className="board_contents">
              <div dangerouslySetInnerHTML={{ __html: inquiryDetail?.contents }}></div>

              {/* 커뮤니티에서 첨부된 파일 표출 */}
              <div className="board_bottom attach_file">
                <div className="img_attach_box">
                  <ul className="preview_list">
                    {inquiryFiles.map((file, index) => (
                      <li className="default_btn ic_lg" key={index}>
                        <img
                          className="object-cover"
                        src={file.new_filepath}
                        alt="이미지 첨부"
                        loading="lazy"
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div> 
            
            {/* 답변 대기중 > 수정 가능 상태 */}
            {inquiryDetail?.re_contents === null && (
              <div className="btn_group edit_box">
                <button 
                  type="button" 
                className="default_btn xs white" 
                onClick={handleCustomizingEdit}
                >
                  {t('modify')}
                </button>
                <button
                  type="button"
                  className="default_btn xs white"
                  onClick={handleDelete}
                >
                  {t('delete')}
                </button>
              </div>
            )}
            
            {/* 답변 완료 > 수정 불가능 */}
            {inquiryDetail?.re_contents && (
              <div className="board_answer unset_box">
                <div dangerouslySetInnerHTML={{ __html: inquiryDetail?.re_contents }}></div>
              </div>
            )}
          </div>
        </div> 

      ) : inquiryType === 'priceGuarantee' ? (
        // 최저가 보장
        <div className="my_container point_container mt_48">
          <div className="order_title">
            <h3>{t('lowest_price_guarantee')}</h3>
          </div>

          <div className="board_container form_board board_detail">
            <ul>
              <li 
                className="board_item"
              >
                <div className="board_box flex-4 column">
                  <h6 className="title flex-center-4 b1-2">
                    <span>{inquiryDetail?.subject}</span>
                  </h6>
                  <div className="board_info board_line">
                    <span className="text_small g-70">{inquiryDetail?.regist_date.split(' ')[0]}</span>
                      <span className="text_small g-70">{inquiryDetail?.board_type}</span>
                  </div>
                </div>

                <div className="board_status">
                  {inquiryDetail?.re_contents ? (
                    <span className="badge g-100">{t('answer_completed')}</span>
                  ) : (
                    <span className="badge yellow">{t('answer_pending')}</span>
                  )}
                </div>
              </li>
            </ul>

            {/* 문의글 */}
            <div className="board_contents ">
              <div dangerouslySetInnerHTML={{ __html: inquiryDetail?.contents }}></div>

              {/* 커뮤니티에서 첨부된 파일 표출 */}
              <div className="board_bottom attach_file">
                <div className="img_attach_box">
                  <ul className="preview_list">
                    {inquiryFiles.map((file, index) => (
                      <li className="default_btn ic_lg" key={index} onClick={() => window.open(file.new_filepath, '_blank')} style={{cursor: 'pointer'}}>
                        <img
                          className="object-cover"
                          src={file.new_filepath}
                          alt="이미지 첨부"
                          loading="lazy"
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div> 
            
            {/* 답변 대기중 > 수정 가능 상태 */}
            {inquiryDetail?.re_contents === null && (
              <div className="btn_group edit_box">
                <button 
                  type="button" 
                  className="default_btn xs white" 
                  onClick={handlePriceGuaranteeEdit}
                >
                  {t('modify')}
                </button>
                <button
                  type="button"
                  className="default_btn xs white"
                  onClick={handleDelete}
                >
                  {t('delete')}
                </button>
              </div>
            )}
            
            {/* 답변 완료 > 수정 불가능 */}
            {inquiryDetail?.re_contents && (
              <div className="board_answer unset_box">
                <div dangerouslySetInnerHTML={{ __html: inquiryDetail?.re_contents }}></div>
              </div>
            )}
          </div>
        </div> 
      ) : null }


      {/* 목록 버튼 */}
      <div className="submit_box">
        <button
          className="default_btn white lg"
          onClick={handleBackToList}
        >{t('list_0617')}
        </button>
      </div>

      <PopupLoginError isPopup={isPopupOpen} setIsPopup={setIsPopupOpen} onConfirm={handleConfirm}/>

    </div>
  )
};

export default InquiryDetail;